import moment from 'moment';
import { guessCurrentTimeZone } from 'utils/datetime/timezone';
import { RELATIVE_DATE_PRESETS } from 'ui/datePicker/helpers';

/**
 * Converts a moment date range to an ISO 8601 period duration
 * @param startDate - Start date moment
 * @param endDate - End date moment
 * @returns ISO 8601 period string (e.g., "P7D")
 */
export const convertDateRangeToPeriod = (
  startDate: moment.Moment | null,
  endDate: moment.Moment | null,
): string => {
  const defaultStartDate = moment().subtract(7, 'days');
  const defaultEndDate = moment();

  const effectiveStartDate = startDate || defaultStartDate;
  const effectiveEndDate = endDate || defaultEndDate;

  const daysDifference = effectiveEndDate.diff(effectiveStartDate, 'days');

  return `P${daysDifference}D`;
};

/**
 * Converts a preset to a date range
 * @param id - Preset id
 * @returns Moment start and end dates
 */
export const convertPresetToDateRange = (id: string) => {
  const preset = RELATIVE_DATE_PRESETS[id as keyof typeof RELATIVE_DATE_PRESETS] as any;
  const timezone = guessCurrentTimeZone();

  return preset.format(timezone);
};

/**
 * Creates campaign query parameters for metrics
 * @param startDate - Start date moment
 * @param endDate - End date moment
 * @returns TIme range object
 */
export const convertDateRangeToISOString = (
  startDate: moment.Moment | null,
  endDate: moment.Moment | null,
): { startTime: string; endTime: string } => ({
  startTime: startDate?.toISOString() || '',
  endTime: endDate?.toISOString() || '',
});
